import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {ErrorSummaries} from 'views/AppLocals/factory/createEditableForm'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import Pure from 'components/Pure'
import {ActionModalWrapper} from 'components/form/ActionModalWrapper'
import {productVariantFormSchema as formSchema} from '../consts/productVariantFormSchema'

export const ProductVariantFormCreate = ({
                                             onCancel = NullAsDefault,
                                             onSubmit = NullAsDefault,
                                         }) => {
    const t = useTranslate()

    const validate = (values) => {
        const {variant_code} = values ?? {}
        return variant_code ? {} : {variant_code: t('required field')}
    }

    const initialValues = useMemo(() => ({active: 1, variant_code: undefined}), [])

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {resetKey, owner_id, owner_type, ...rest} = values ?? {}
                onSubmit(_.omitBy(rest, _.isUndefined))
            }}>
            <React.Fragment>
                <ActionModalWrapper
                    action={<FormActionGroups submitProps={{label: 'create'}}/>}>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.active, formSchema.variant_codes]}/>
                        </Pure>
                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.rate_qtty]}/>
                        </Pure>
                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.attribute_1, formSchema.attribute_2]}/>
                        </Pure>
                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

export const ProductVariantFormEdit = ({
                                           onCancel = NullAsDefault,
                                           onSubmit = NullAsDefault,
                                           initialValues = {},
                                       }) => {
    const t = useTranslate()

    const _initialValues = useMemo(() => ({...initialValues ?? {}}), [initialValues])

    const validate = (values) => {
        const {variant_code} = values ?? {}
        return variant_code ? {} : {variant_code: t('required field')}
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {resetKey, status_options, ...rest} = changes ?? {}
                onSubmit(_.omitBy(rest, _.isUndefined))
            }}>
            <React.Fragment>
                <ErrorSummaries/>
                <ActionModalWrapper
                    action={<FormActionGroups submitProps={{label: 'save'}}/>}>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.active, formSchema.variant_codes]}/>
                        </Pure>
                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.rate_qtty]}/>
                        </Pure>
                    </div>
                    <div className="flex flex-col gap-3">
                        <Pure>
                            <FieldsFactory formSchema={[formSchema.attribute_1, formSchema.attribute_2]}/>
                        </Pure>
                    </div>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}
